import React, { useState } from "react";
import awsExports from "../aws-exports";
import { safeParseLocalStorage } from "../utils/safeParseLocalStorage";

export const BoerderyContext = React.createContext({
  boerdery: {},
  setBoerdery: () => {},
  boerderye: [],
  setBoerderye: () => {},
  modules: [],
  setModules: () => {},
  disabled: false,
  setDisabled: () => {},
  reload: false,
  setReload: () => {},
  refreshpage: false,
  setRefreshpage: () => {},
  klient: {},
  setKlient: () => {},
  kliente: [],
  setKliente: () => {},
});

const BoerderyContextProvider = (props) => {
  const [boerdery, setBoerdery] = useState(safeParseLocalStorage("boerdery", null));
  const [boerderye, setBoerderye] = useState(safeParseLocalStorage("boerderye", null));
  const [modules, setModules] = useState(safeParseLocalStorage("modules", []));
  const [disabled, setDisabled] = useState(false);
  const [reload, setReload] = useState(0);
  const [refreshpage, setRefreshpage] = useState(false);

  const boerderyHandler = (boerdery) => {
    setBoerdery(boerdery);
    localStorage.setItem("boerdery", JSON.stringify(boerdery));
    localStorage.setItem(
      "bucket",
      `${awsExports.aws_user_files_s3_bucket}/public`
    );
  };

  const boerderyeHandler = (boerderyein) => {
    setBoerderye(boerderyein);
    localStorage.setItem("boerderye", JSON.stringify(boerderyein));
  };

  const modulesHandler = (module) => {
    setModules(module);
    localStorage.setItem("modules", JSON.stringify(module));
  };

  const disabledHandler = (disabled) => {
    setDisabled(disabled);
    localStorage.setItem("disabled_boerdery", disabled);
  };

  const [klient, setKlient] = useState(safeParseLocalStorage("klient", null));
  const [kliente, setKliente] = useState(safeParseLocalStorage("kliente", null));

  const klientHandler = (klient) => {
    setKlient(klient);
    localStorage.setItem("klient", JSON.stringify(klient));
  };

  const klienteHandler = (klientein) => {
    setKliente(klientein);
    localStorage.setItem("kliente", JSON.stringify(klientein));
  };

  return (
    <BoerderyContext.Provider
      value={{
        stelboerdery: boerderyHandler,
        boerdery: boerdery,
        stelboerderye: boerderyeHandler,
        boerderye: boerderye,
        stelmodules: modulesHandler,
        modules: modules,
        steldisabled: disabledHandler,
        disabled: disabled,
        reload: reload,
        stelreload: setReload,
        refreshpage: refreshpage,
        stelrefresh: setRefreshpage,
        stelklient: klientHandler,
        klient: klient,
        stelkliente: klienteHandler,
        kliente: kliente,
      }}
    >
      {props.children}
    </BoerderyContext.Provider>
  );
};

export default BoerderyContextProvider;
